import { Block } from '@components/core-ui/Block';

import { Textarea } from '@components/core-ui/form-elements/Textarea';
import { usePageContext } from '@pages/User/NewJobPage/providers/PageProvider';
import React from 'react';

export const NotesBlock = () => {
  const { form, setFormItemValue } = usePageContext();

  const handleInputChange = async (evt: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const { name, value } = evt.target;
    setFormItemValue(name, value);
  };

  const notesDescription = <p>You can provide additional information</p>;

  return (
    <Block title="Notes" description={notesDescription}>
      <Textarea onChange={handleInputChange} name="notes" label="Type your notes here" value={form.item?.notes ?? ''} />
    </Block>
  );
};
